var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('Container',[_c('div',{staticClass:"header__logo"},[_c('Logo')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }